/// <reference path="DOMAttached.js" />

class HideableControl extends DOMAttached {
	constructor(el, options) {
		super(el, options);
		this.hidden_control = document.getElementById(options.hidden_control);
		this.replacement = document.getElementById(options.replacement);
		this.trigger = document.getElementById(options.trigger);
		this.hidden_control.style.display = this.hidden_control.style.display === 'none' ? '' : 'none';
		this.safeObserve(this.trigger, 'click', this.change.bind(this));
	}

	change() {
		this.replacement.style.display = this.replacement.style.display === 'none' ? '' : 'none';
		this.hidden_control.style.display = this.hidden_control.style.display === 'none' ? '' : 'none';
	}
}
